<script lang="tsx" setup>
import { FormElementBase } from "~/api";

const props = defineProps<{
  modelValue: FormElementBase;
}>();
</script>

<template>
  <el-tooltip
    v-if="props.modelValue.properties.title"
    placement="top"
    class="tooltip"
    :effect="'light'"
    :enterable="true"
  >
    <template #content>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-html="props.modelValue.properties.title"></div>
    </template>
    <el-icon>
      <el-icon-question-filled />
    </el-icon>
    <span>{{ props.modelValue.properties.title }}</span>
  </el-tooltip>
</template>
